import React, { useCallback, useEffect, useState } from 'react';
import { supabaseClient } from '@/services/supabase';
import { needsMfaVerification } from '@/services/authSecurity';
import { MfaChallengeScreen } from './MfaChallengeScreen';
import { PageLoading } from '@/components/PageLoading';

type AuthenticatedMfaGateProps = {
    children: React.ReactNode;
};

export const AuthenticatedMfaGate: React.FC<AuthenticatedMfaGateProps> = ({ children }) => {
    const [isChecking, setIsChecking] = useState(true);
    const [mfaRequired, setMfaRequired] = useState(false);

    const refreshMfaRequirement = useCallback(async () => {
        setIsChecking(true);
        try {
            setMfaRequired(await needsMfaVerification());
        } catch (error) {
            console.error('Failed to check MFA requirement:', error);
            setMfaRequired(false);
        } finally {
            setIsChecking(false);
        }
    }, []);

    useEffect(() => {
        void refreshMfaRequirement();
    }, [refreshMfaRequirement]);

    useEffect(() => {
        const { data: { subscription } } = supabaseClient.auth.onAuthStateChange(() => {
            void refreshMfaRequirement();
        });
        return () => subscription.unsubscribe();
    }, [refreshMfaRequirement]);

    if (isChecking) {
        return <PageLoading />;
    }

    if (mfaRequired) {
        return <MfaChallengeScreen onVerified={() => setMfaRequired(false)} />;
    }

    return <>{children}</>;
};
